// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2GtBZ","label":"Section_label__3aRli","contentWrap":"Section_contentWrap__3EHdG","footer":"Section_footer__1TRQV","footerInner":"Section_footerInner__3KYVJ"};